import { ItemElement } from './common.types';
//---------------------------------
//-------------ENUMS---------------
//---------------------------------
export enum Social {
  FACEBOOK = 'facebook',
  GITHUB = 'github',
  INSTAGRAM = 'instagram',
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube',
}

//---------------------------------
//------------TYPES----------------
//---------------------------------
export type SocialItem = ItemElement & {
  name: Social;
};

